import { Components } from "@thisgorilla/primate-ds";
import { useMemo, useState } from "react";
import styled, { useTheme } from "styled-components";
import { useAppSelector } from "../../../../../../redux";
import { FlexRow } from "../../../../../Common/Styles";
import { usePostCardContext } from "../PostCardContent";
import { PostCardOptions } from "./PostCardOptions";
import { UserAddOrRemoveToCircle } from "./UserAddOrRemoveToCircle";

export const HeaderRight = () => {
  const { Color } = useTheme();
  const [circleDropdownOpen, setCircleDropdownOpen] = useState(false);
  const { listOfCircles } = useAppSelector((state) => state.circle);
  const { processed_posts } = useAppSelector((state) => state.newsfeed);
  const {
    postId,
    setShowPostCardOptions,
    showPostCardOptions,
    isWithinRepostModal,
    isWithinRepostPost,
  } = usePostCardContext();

  const user_id = processed_posts[postId].UserDetails.user_id;
  const selectedCircle = useMemo(() => {
    return listOfCircles.filter((circle) =>
      (circle.circle_user_ids || []).includes(user_id)
    );
  }, [listOfCircles, user_id]);

  const HeaderContentOnPost = (
    <Container $gapInPx={4}>
      <IconButtonContainer>
        <Components.SplitButton
          IconPosition="left"
          icon={selectedCircle.length === 0 ? "Circle" : undefined}
          iconColor={Color.icon["icon-primary"].value}
          title={
            selectedCircle.length > 0 && (
              <IconContainer $gapInPx={0}>
                {selectedCircle.map((circle) => (
                  <Components.Icon
                    key={circle.id}
                    type="Circle"
                    size="16px"
                    color={circle.colour}
                  />
                ))}
              </IconContainer>
            )
          }
          size="small"
          variant="secondary"
          ListIconsPosition="right"
          leftBtnstyle={`
          border-color:${
            selectedCircle.length === 0
              ? "transparent"
              : Color.border["ui-border-subtle"].value
          };
          border-radius:4px;
         svg path {
          stroke-width: 3px;
        }`}
          rightBtnstyle="display: none;"
          onLeftClick={() => {
            setCircleDropdownOpen(!circleDropdownOpen);
          }}
        />
        {circleDropdownOpen && (
          <UserAddOrRemoveToCircle
            setCircleDropdownOpen={setCircleDropdownOpen}
            circleDropdownOpen={circleDropdownOpen}
          />
        )}
      </IconButtonContainer>
      <IconButtonContainer>
        <Components.IconButton
          disabled={false}
          iconType="MoreHorizontal"
          kind="Tertiary"
          size="Small"
          onClick={() => setShowPostCardOptions((prev) => !prev)}
        />
        {showPostCardOptions && <PostCardOptions />}
      </IconButtonContainer>
    </Container>
  );

  const HeaderContentOnRepost = (
    <Components.Button
      kind="Secondary"
      color="Neutral"
      size="XS"
      disabled={false}
      label="Follow"
      iconPosition="left"
      iconType="Plus"
      onClick={() => {}}
    />
  );

  const isWithinRepost = isWithinRepostModal || isWithinRepostPost;
  return (
    <Container $gapInPx={4}>
      {isWithinRepost ? HeaderContentOnRepost : HeaderContentOnPost}
    </Container>
  );
};

const Container = styled(FlexRow)``;
const IconButtonContainer = styled.div`
  position: relative;
  height: fit-content;
`;

const IconContainer = styled(FlexRow)`
  & svg {
    margin-left: -6px;
    &:first-child {
      margin-left: 0px;
    }
  }
`;
